import logger from '@/libs/Logger';

/**
 * Logger interface that accepts flexible parameter types
 */
export interface Logger {
  info: (msg: string, obj?: unknown) => void;
  warn: (msg: string, obj?: unknown) => void;
  error: (msg: string, obj?: unknown) => void;
  debug: (msg: string, obj?: unknown) => void;
  trace: (msg: string, obj?: unknown) => void;
}

/**
 * Custom hook to get the logger instance.
 * This provides a convenient way to access the logger from within React components.
 *
 * @returns {Logger} The logger instance.
 * @example
 * const logger = useLogger();
 * logger.info('Component mounted');
 */
export const useLogger = () => {
  return logger;
};
